import { emailValidationYup, numValidation } from "helpers/validations"
import { t } from "i18next"
import { isValidPhoneNumber } from "react-phone-number-input"
import * as yup from "yup"

const getClientLeadValidationSchema = () =>
  yup.object().shape({
    searchBy: yup.string().required(t("Search by is required")).nullable(),
    mobileNumber: yup.string().when("searchBy", {
      is: "phone",
      then: () =>
        yup
          .string()
          .test("required", t("Phone number is required"), value => {
            return !value ? false : true
          })
          .test("valid", t("Invalid Phone Number"), value => {
            return isValidPhoneNumber(value ? value : "-")
          }),
      otherwise: () => yup.string().nullable(),
    }),
    email: yup.string().when("searchBy", {
      is: "email",
      then: () => emailValidationYup(true).nullable(),
      otherwise: () => yup.string().nullable(),
    }),
    searchAffiliate: yup.object().required(t("This Field needs to be selected")).nullable(),
    searchId: numValidation(t("Search ID is required"), 15, "naturalNumbers"),
  })

export default getClientLeadValidationSchema
